export default "__VITE_ASSET__BA8l5MvC__"